<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid

            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col cols="12">
                        <v-expand-transition>
                            <v-card 
                                width="400"
                                v-show="expand"
                                class="elevation-12 mx-auto pa-4 "
                            >                            
                                <v-row
                                    justify="center"
                                    class="pt-4"
                                >
                                    <v-img
                                        src="../../assets/logo.png"
                                        max-width="150"
                                        contain
                                        class="d-flex"
                                    ></v-img>
                                </v-row>
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <div 
                                            class="pa-4"
                                            v-if="getloginErrors"
                                        >
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                
                                                class="red--text"
                                            >
                                                {{ getloginErrors }}
                                            </v-alert>    
                                        </div>
                                        
                                        <div 
                                            class="pa-4"
                                            v-if="validationErrors"
                                        >
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                
                                                class="red--text"
                                            >
                                                {{ validationErrors }}
                                            </v-alert>    
                                        </div> 
                                        
                                        <div class="text-center font-weight-light primary--text mt-6">Welcome to</div>
                                        <div 
                                            class="text-h4 text-sm-h5 font-weight-black text-center primary--text"
                                            v-html="schoolName"
                                        ></div>        
                                        <v-card-text>
                                            <div class="primary--text text-h5 text-center">Student Registration Portal</div>                                            
                                        </v-card-text>

                                        <v-form 
                                            class="pa-5 mb-4"
                                            @submit.prevent
                                        >
                                            <v-text-field
                                                label="SEA Number / Birth Certificate Pin"                                                
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.birth_certificate_pin"
                                                clearable
                                                autofocus
                                                v-on:keyup="keyPressId" 
                                                :rules="[rules.required]"                                                 
                                            >
                                                <v-icon
                                                    slot="prepend"
                                                    color="primary"
                                                >
                                                    mdi-account
                                                </v-icon>
                                            </v-text-field> 

                                            <v-menu
                                                ref="menuDateOfBirth"
                                                v-model="menuDateOfBirth"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs}">
                                                    <v-text-field
                                                        v-model="dateOfBirthFormatted"
                                                        label="Date of Birth"
                                                        hint="DD/MM/YYYY"
                                                        persistent-hint
                                                        prepend-icon="mdi-calendar"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @blur="dateOfBirth = parseDate(dateOfBirthFormatted)"
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateOfBirth"
                                                    :active-picker.sync="activePicker"
                                                    :max="(new Date(Date.now()-(new Date()).getTimezoneOffset()*6000)).toISOString().substring(0,10)"
                                                    min="1950-01-01"
                                                    @input="menuDateOfBirth = false"
                                                ></v-date-picker>
                                            </v-menu>
                                    
                                            <div 
                                                class="text-right mt-6 pt-4"
                                            >                                                
                                                <v-btn 
                                                    color="primary" 
                                                    @click="submit" 
                                                    dark
                                                    block
                                                >LOGIN</v-btn>
                                            </div>
                                             
                                        </v-form>        
                                    </v-col>
                                </v-row>

                                <!-- <v-card-actions>
                                    <div>
                                        <v-btn
                                            v-if="studentIdQuery"
                                            text
                                            color="indigo darken-4"
                                            class="text-caption mt-5"
                                            @click="openDialog(true)"
                                        >
                                            Click here to get your student ID
                                        </v-btn>
                                    </div>    
                                </v-card-actions> -->
                                  
                                                                 
                               
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
            </v-container>            
        </v-main>        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        //
    },
    data(){
        return {            
            show: false,
            formData: {
                birth_certificate_pin: '',
                date_of_birth: '',
            },
            password: true,
            studentIdQuery: true,            
            expand: true,
            date: null,
            menuDateOfBirth: false,
            dateOfBirth: null,
            activePicker: null,
            validationErrors: null,
            rules: {
                required: value => !!value || 'Required.',
            },
        }
    },

    props: {
        source: String,
    },

    watch: {
        
        menuDateOfBirth (val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        }
    },

    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',
            getloginErrors: 'auth/getLoginErrors',
            authenticated: 'auth/getAuthenticated',
            passwordHint: 'auth/getPasswordHint',
        }),

        dateOfBirthFormatted () {
            if(!this.dateOfBirth) return null;
            const [year, month, day] = this.dateOfBirth.split('-');
            return `${day}/${month}/${year}`;
        }
        
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
        }),

        ...mapMutations({
            openDialog: 'auth/setDialog',
            setOverlay: 'auth/setOverlay',
        }),

        keyPressPassword (e) {            
            if(e.keyCode === 13){
                this.submit();
            }
        },

        keyPressId (e) {
            if(e.keyCode === 13){
                this.$refs.password.focus();
            }
        },       

        async submit () {                     
            console.log('Authenticating..');
            this.formData.date_of_birth = this.dateOfBirth
            console.log('form data: ', this.formData);
            if(!this.formData.birth_certificate_pin || !this.formData.date_of_birth){
                this.validationErrors = "Please fill out missing Fields to continue."
            }
            await this.signIn(this.formData);
            if(this.authenticated){ 
                console.log('Authenticated');               
                this.$router.replace('/registration/student-data');
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }
            this.setOverlay(false);                     
        },

        parseDate (date) {
            if(!date) return null;
            const [day, month, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

    }
}
</script>

<style scoped>
    .container-background{
        /* background-image: url('../../assets/background.jpg'); */
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    
</style>

